module.exports = __webpack_public_path__ + "f89c847ab0c8a5c8193d610dac6386bd.svg";